import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../../hooks/useAuth';
import { useFirebase } from '../../../hooks/useFirebase';
import { queryGet, queryPut } from '../../tools/tools';

const ENDPOINT = '/sales/config';
const KEY = 'sales-config';

export const useSalesConfig = () => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();
  const queryClient = useQueryClient();

  const queryKey = [KEY, user?.uid];

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => queryGet(remoteConfig, ENDPOINT, user?.accessToken),
    enabled: !!user?.accessToken && !!remoteConfig
  });

  const updateMutation = useMutation({
    mutationFn: (config) => queryPut(remoteConfig, ENDPOINT, config, user?.accessToken),
    onSuccess: () => queryClient.invalidateQueries({ queryKey })
  });

  return {
    config: data ?? {},
    isLoading,
    update: updateMutation.mutate,
    isUpdating: updateMutation.isPending
  };
};
